
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Forever Lata : <span > - A Musical Tribute to Bharat Ratna Lata Mangeshkar
                        Bhandara</span></h2>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-justify">G. H Raisoni Sports and Cultural Foundation organizes ‘Forever Lata’ - A
                        Musical Tribute to Lata Mangeshkar ji. The event is powered by the Raisoni Group of Institutions
                        and supported by G H Raisoni University, and SGR Knowledge Foundation. ‘Forever Lata’ is a
                        heartfelt tribute that aims to celebrate the exceptional music of the legendary singer Lata
                        Mangeshkar. The grand event features a group of highly talented and well-known artists from
                        Nagpur’s musical group ‘Sur Sangam’, who performs Lata Mangeshkar's timeless songs, recalling
                        her immense contribution to Indian cinema. </p>
                    <p class="text-justify">Earlier GHRSCF had organized the event in Nagpur, Chandrapur, Wardha and
                        extended to other different cities across Maharashtra. The event’s success usually depends on
                        the testament to the passion and commitment of the organizer G H Raisoni Sports and Cultural
                        Foundation fits in and celebrates India’s rich cultural heritage by organizing such events for
                        the general public, free of charge. The Initiative is supported and encouraged by Shri Sunil
                        Raisoni, Chairman, Raisoni Group of Institutions, He has been a driving force behind the event,
                        and has made this initiative possible.</p>
                    <p class="text-justify">All the music enthusiasts, cinephiles, and the general public are invited to
                        join the upcoming event. For more details and registration visit the following link <a
                            href="https://www.ghrscf.com/cultural-events">Link:-https://www.ghrscf.com/cultural-events</a>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">

                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Topic: A Musical Tribute to Bharat Ratna - Lata Mangeshka </b></p>
                    <p><b>Date – Friday, 26<sup>th</sup> May 2023 </b></p>
                    <p><b>Time – 06:30 pm - Sharp (Grab your seats before time)</b></p>
                    <p><b>Venue: Laxmi Sabhagrah and Lawns .J.M PATEL College Road , Bhandara, 441904</b></p>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-mangeshkar-bhandara.webp"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#lata-mageshkar-bhandara-event" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Testimonial</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a routerLink="/testimonial" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="240" src="https://www.youtube.com/embed/3dJnSjbzEEo"
                        title="Forever Lata: A Musical Tribute to Lata Mangeshkar | GHRSCF Event Highlights #bhandara"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
